// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"604":"company","791":"companyPublic","843":"preisrechner","884":"admin"}[chunkId] + "." + {"604":"d50fa463","791":"7157ddfe","843":"5142ae5d","884":"461f266c"}[chunkId] + ".css";
};